import styled from 'styled-components';

export const BKPayLogoButton = styled.button`
  border: none;
  background: none;
  display: flex;
  padding-inline-start: 7px;
`;
